import React from 'react';
import { Badge, BadgeProps } from 'components';
import styled from 'styled-components';

const DotEntry: React.FC<BadgeProps & { visible: boolean }> = ({
  visible,
  ...badgeProps
}) => (
    <StyledDotContainer>
      {visible && <Badge dot dotSize="large" {...badgeProps} />}
    </StyledDotContainer>
  );

export default DotEntry;

const StyledDotContainer = styled.div`
  width: 12px;
  height: 'max-content';
`;
